// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"351":"38abbf4ecc89cb26f3e7","678":"a7cb3664e14c2a5b9bc2","731":"60021b92498054506845","843":"21f169abc2f9ef161695","883":"c14a6e51d4ed8d8f572d"}[chunkId] + ".js";
};